import { render, staticRenderFns } from "./pointDeduction.vue?vue&type=template&id=2b419739&scoped=true"
import script from "./pointDeduction.vue?vue&type=script&lang=js"
export * from "./pointDeduction.vue?vue&type=script&lang=js"
import style0 from "./pointDeduction.vue?vue&type=style&index=0&id=2b419739&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b419739",
  null
  
)

export default component.exports